/* GENERADO — no editar a mano.
 *
 * Derivado de flow/src/components/shared/blocks/EditorialSplit/EditorialSplit.tsx quitandole los tipos, para
 * que la previsualizacion del back office editorial monte los MISMOS
 * componentes que renderiza /historias/[slug] en el sitio publico.
 *
 * Se regenera con:                 npm run historia:sync
 * Se verifica (falla si difiere):   npm run historia:diff
 *
 * Un cambio en el componente de flow se trae con `historia:sync`. Editar este
 * archivo directamente lo pierde en la siguiente regeneracion — y peor: hace
 * que la previsualizacion muestre algo distinto de lo que se publica, que es
 * justo lo que esa pantalla existe para evitar.
 *
 * La salida definitiva es publicar estos componentes en el Design System y que
 * los dos repos los consuman; ver
 * docs/superpowers/specs/2026-08-26-editorial-design-system-design.md §5.
 */
/*
 * Portado 1:1 desde Yool Design System
 * Fuente: yool-design-system/project/components/blocks/EditorialSplit/EditorialSplit.tsx
 * Import Button: relativo (../../primitives/Button/Button), consistent con ProductBand
 */
import React from 'react';
import { renderHighlighted } from './highlight';
import { Button } from './Button';
/* Editorial block: a text card next to a photo. Used for B2B ("Yool para
   empresas") and any "story beside an image" layout. */
export const EditorialSplit = ({
  eyebrow,
  title,
  highlight,
  highlightColor = 'blue',
  text,
  image,
  imagePosition = 'center',
  imageSide = 'right',
  height = 380,
  background = 'light',
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary
}) => {
  const cardBg = !background || background === 'light' ? 'var(--yool-page)' : background;
  const paras = (text || '').split('\n').filter(Boolean);
  const textCard = <div className="yool-es-card" style={{
    background: cardBg,
    borderRadius: 18,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    boxShadow: 'var(--shadow-sm)'
  }}>
      {eyebrow && <div style={{
      font: '600 11px/1 var(--font-sans)',
      letterSpacing: '.1em',
      textTransform: 'uppercase',
      color: 'var(--yool-muted)',
      marginBottom: 14
    }}>
          {eyebrow}
        </div>}
      <h3 style={{
      margin: 0,
      font: '700 clamp(28px,3vw,40px)/1.1 var(--font-sans)',
      letterSpacing: '-0.035em',
      color: 'var(--yool-black)'
    }}>
        {renderHighlighted(title, highlight, highlightColor)}
      </h3>
      {paras.map((p, k) => <p key={k} style={{
      margin: k === 0 ? '18px 0 0' : '14px 0 0',
      font: '400 16px/1.7 var(--font-sans)',
      color: 'var(--yool-gray1)',
      maxWidth: '54ch'
    }}>
          {p}
        </p>)}
      {(primaryLabel || secondaryLabel) && <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      marginTop: 26
    }}>
          {primaryLabel && <Button variant="primary" onClick={onPrimary}>
              {primaryLabel}
            </Button>}
          {secondaryLabel && <Button variant="outline" onClick={onSecondary}>
              {secondaryLabel}
            </Button>}
        </div>}
    </div>;
  const photo = <div className="yool-es-photo" style={{
    position: 'relative',
    borderRadius: 18,
    overflow: 'hidden',
    minHeight: height,
    background: 'var(--yool-page)',
    boxShadow: 'var(--shadow-sm)'
  }}>
      {image && <img src={image} alt="" aria-hidden="true" style={{
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: imagePosition
    }} />}
    </div>;
  return <div className={`yool-editorial-split yool-es-side-${imageSide}`} style={{
    display: 'grid',
    alignItems: 'stretch'
  }}>
      <style>{`
        .yool-editorial-split { gap: 28px; }
        .yool-es-side-left { grid-template-columns: 0.85fr 1.15fr; }
        .yool-es-side-right { grid-template-columns: 1.15fr 0.85fr; }
        .yool-es-card { padding: 44px; }
        @media (max-width: 880px) {
          .yool-editorial-split { gap: 20px; }
          .yool-es-side-left, .yool-es-side-right { grid-template-columns: 1fr; }
        }
        @media (max-width: 520px) {
          .yool-es-card { padding: 28px; }
          .yool-es-photo { min-height: 220px !important; }
        }
      `}</style>
      {imageSide === 'left' ? <>
          {photo}
          {textCard}
        </> : <>
          {textCard}
          {photo}
        </>}
    </div>;
};
export default EditorialSplit;
